import { tx as translateInterfaceText } from '@/utils/i18n';
/**
 * Comprime uma imagem base64 redimensionando e convertendo para JPEG
 * @param base64 - String base64 da imagem original
 * @param maxWidth - Largura máxima da imagem (default: 400px)
 * @param quality - Qualidade JPEG de 0 a 1 (default: 0.7)
 * @returns Promise com a string base64 da imagem comprimida
 */
export async function compressImage(
  base64: string,
  maxWidth = 400,
  quality = 0.7
): Promise<string> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    
    img.onload = () => {
      const canvas = document.createElement('canvas');
      let width = img.width;
      let height = img.height;

      // Redimensionar se maior que maxWidth
      if (width > maxWidth) {
        height = (height * maxWidth) / width;
        width = maxWidth;
      }

      canvas.width = width;
      canvas.height = height;

      const ctx = canvas.getContext('2d');
      if (!ctx) {
        reject(new Error(translateInterfaceText("Não foi possível criar contexto do canvas")));
        return;
      }

      ctx.drawImage(img, 0, 0, width, height);

      // Converter para JPEG com qualidade reduzida
      const compressedBase64 = canvas.toDataURL('image/jpeg', quality);
      resolve(compressedBase64);
    };

    img.onerror = () => {
      reject(new Error(translateInterfaceText("Erro ao carregar imagem")));
    };

    img.src = base64;
  });
}

/**
 * Calcula o tamanho aproximado de uma string base64 em bytes
 */
export function getBase64Size(base64: string): number {
  const base64Length = base64.length - (base64.indexOf(',') + 1);
  return Math.floor((base64Length * 3) / 4);
}

/**
 * Converte bytes para formato legível
 */
export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(2)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
}
